<template>
    <div>
        <div class="action-banner">
            <span class="action-accent"></span>
            <span class="action-label">Ação</span>
            <strong class="action-value title">{{ description }}</strong>
        </div>

        <div class="status-header">
            <div class="status-chip">
                <i class="fas fa-list"></i>
                <span>Total {{ total }}</span>
            </div>
            <div class="status-chip success">
                <i class="fas fa-check-circle"></i>
                <span>Concluídos {{ done }}</span>
            </div>
            <div class="status-chip error-chip">
                <i class="fas fa-times-circle"></i>
                <span>Falhas {{ errors }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ActionModalHeader",
    props: {
        description: { type: String, default: "" },
        total: { type: Number, default: 0 },
        done: { type: Number, default: 0 },
        errors: { type: Number, default: 0 },
    },
};
</script>

<style scoped>
.status-header {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 10px;
    padding: 8px 0;
}

.status-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    border-radius: 20px;
    padding: 6px 10px;
    font-size: 13px;
    color: #374151;
}

.status-chip.success {
    background: #ecfdf5;
    border-color: #a7f3d0;
    color: #065f46;
}

.status-chip.success i {
    color: #16a34a;
}

.status-chip.error-chip {
    background: #fef2f2;
    border-color: #fecaca;
    color: #b91c1c;
}

.status-chip.error-chip i {
    color: #dc2626;
}

.action-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    margin-bottom: 12px;
    background: #f8fafc;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
}

.action-accent {
    width: 4px;
    align-self: stretch;
    background: #3b82f6;
    border-radius: 8px;
}

.action-label {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #64748b;
}

.action-value {
    font-size: 14px;
    color: #0f172a;
    font-weight: 700;
}
</style>
